module.exports = __webpack_public_path__ + "img/chevron-down-white.8ec4c1c6.svg";